<template>
    <div style="background-color: #F8F9FB;">
        <hhead></hhead>
        <crm-nav></crm-nav>
        <div class="jgMsg_box">
            <div class="jgMsg" :style="{
          minHeight: MHeight,
          boxSizing: 'border-box',
          minWidth: '1200px',
        }">
                <div style="display: flex;width: 1018px;" class="searchBox">
                    <div class="addBtn" @click=add style="width: 120px;margin-bottom: 0;margin-right: 20px;">
                        <i class="el-icon-plus"></i>添加合作
                    </div>
                    <div class="se" style="width:185px;">
                        <el-input  v-model='contractNum' placeholder="请输入合作编号"></el-input>
                    </div>

                    <div class="se" style="width:185px;">
                        <el-input  v-model='investorName' placeholder="请输入合作方名称"></el-input>
                    </div>
                    <div style="width: 185px;margin-right: 20px;">
                        <el-select filterable v-model="value" placeholder="请选择合作状态">
                            <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>

                    <div style="display: flex;margin-top: 15px;">
                        <input class="btn" type="button" @click="search" value="搜索" />
                        <input style="color: #fff;background-color: #5B85FF;" class="btn" type="reset" @click="reset"
                            value="重置" />
                    </div>

                </div>



                <div class="table" style="margin-top: 40px;">
                    <el-table border :data='contractList' size="medium" style="width: 100%"
                        :header-cell-style="{textAlign: 'center'}">
                        <el-table-column width='80' prop="" align="center" label="查看详情">
                            <template slot-scope="scope">
                                <span class="decoration" @click=details(scope.row.investorId,scope.row.id)
                                    style="color: #3D6BF1;cursor: pointer;">详情</span>
                            </template>
                        </el-table-column>
                        
                        <el-table-column width='90' prop="" align="center" label="操作">
                            <template slot-scope="scope">
                                <span :class="{decoration:scope.row.state==0?true:false}"
                                    @click=hzStop(scope.row.id,scope.row.contractNum,scope.row.state)
                                    :style="{color:scope.row.state==2?'#868E99':'#3D6BF1',cursor: 'pointer'}">合作终止</span>
                                <!-- <span  style="color:#DDE0E7">丨</span> -->
                                <!-- <span @click=htStop(scope.row.id,scope.row.contractNum,scope.row.state) style="color: #3D6BF1;cursor: pointer;">合作暂停</span> -->

                            </template>
                        </el-table-column>
                        <el-table-column prop="contractNum" label="合作编号" align="center">
                        </el-table-column>


                        <el-table-column prop="invSimpleName" align="center" label="合作方">
                        </el-table-column>
                        <el-table-column align="center" label="合作起始时间">
                            <template slot-scope="scope">
                                <span>{{scope.row.startTime|datas}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="合作终止时间">
                            <template slot-scope="scope">
                                <span>{{scope.row.endTime|datas}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cooCycle" align="center" label="合作周期">
                        </el-table-column>
                        <el-table-column width='80' prop="" align="center" label="附件">
                            <template slot-scope="scope">
                                <a :href="api + scope.row.contractFile"
                                    style="color: #3D6BF1;cursor: pointer;font-size: 17px;"
                                    class=" iconfont icon-hetong decoration"></a>
                            </template>
                        </el-table-column>
                        <el-table-column width='90' prop="" align="center" label="续签">
                            <template slot-scope="scope">
                                <span :class="{decoration:scope.row.state==0?true:false}"
                                    @click=RenewalBtn(scope.row.contractNum,scope.row.invSimpleName,scope.row.startTime,scope.row.id,scope.row.state)
                                    :style="{color:scope.row.state==0?'#3D6BF1':scope.row.state==2?'#868E99':'',cursor:'pointer'}">续签</span>
                            </template>
                        </el-table-column>
                        <el-table-column width='90' align="center" label="合作状态">
                            <template slot-scope="scope">
                                <span class="stateYuan" :style="{color:scope.row.state==0?'#31b4ff':scope.row.state==2?'#fb6060':'',
                  background:scope.row.state==0?'#ebf9ff':scope.row.state==2?'#fff5f4':'',padding:'4px 1px 4px 10px',
                    display:'block',
                    borderRadius: '6px',position:'relative'
                }"><i :style="{display:'inline-block',borderRadius: '50%',width: '5px',height:'5px',
                background:scope.row.state==0?'#31b4ff':scope.row.state==2?'#fb6060':'',position:'absolute',top:'11px',left:'10px'
            }"></i> {{scope.row.state==0?'合作中':(scope.row.state==1?'合作暂停': '已终止')}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column width='90' align="right" label="累计">
                            <template slot-scope="scope">
                                <span
                                    :style="{color:scope.row.profitRate>=0?'#FA5D22':'#3ABA94'}">{{scope.row.profitRate|num}}</span>
                            </template>
                        </el-table-column>
                       

                        <el-table-column width='62' prop="" align="center" label="删除">
                            <template slot-scope="scope">
                                <span @click=del(scope.row.id,scope.row.contractNum)
                                    style="color: #3D6BF1;cursor: pointer;"
                                    class="iconfont icon-shanchu decoration"></span>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
                <div class="page_box">
                    <div class="msg_count">共&nbsp;{{ length?length:'0' }}&nbsp;条</div>
                    <div class="blank"></div>
                    <div class="page">
                        <el-pagination background layout="prev, pager, next" :total="pageLength ? pageLength : 0"
                            @current-change="currentPage">
                        </el-pagination>
                    </div>
                </div>




            </div>
        </div>

        <transition name="el-fade-in-linear">
            <!--  添加遮罩层 -->
            <div class="popContainer" v-show="addShow">
                <div class="add" :style="{ width: '680px',paddingBottom:'20px' }">
                    <div class="close"></div>
                    <div class="Top" :style="{ width: '680px' }">
                        添加合作
                    </div>
                    <span class="close iconfont icon-close_round_fill_bold
        " @click="add_close"></span>
                    <div class="form_box" style="width: 100%;">
                        <div class="form" style="display: block;width: 480px;margin-left: 58px;">

                            <!-- 添加合作 -->
                           
                            <!-- <div class="col" style="margin-bottom: 20px;">
                <div class="left"><span>*&nbsp;</span>附件上传</div>
                <div class="right">
                  <p style="font-size: 14px;color: #475173;margin-top: 7px;margin-bottom: 5px;">请上传尽调表。 </p>

                  <el-upload
                    class="avatar-uploader"
                    :action="this.$store.state.api + '/ad/upload/upload_file'"
                    :on-remove = "delBtn_t"
                    name="file"
                    accept=".docx,.doc"
                    :limit=1
                    :on-success="handleAvatarSuccess_t"
                  >
                    <i
                      style="color: #fff;width: 80px;height: 24px;background-color: #62DCB5;text-align: center;border-radius: 2px;display: block;font-size: 14px;line-height: 24px;"                   
                      
                    >上传文件</i>
                  </el-upload>
                </div>
              </div> -->

                            <!--  合起始日 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>合作起始日</span></div>
                                <div class="right">
                                    <el-date-picker v-model="startDate" type="date" value-format="yyyy/MM/dd"
                                        placeholder="请选择合作开始日期">

                                    </el-date-picker>
                                </div>
                            </div>

                            <!--  合作结束日 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>合作结束日</span></div>
                                <div class="right">
                                    <el-date-picker v-model="endDate" type="date" value-format="yyyy/MM/dd"
                                        placeholder="请选择合作结束日期">
                                    </el-date-picker>
                                </div>
                            </div>

                            <!--  合作编号 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>合作编号</span></div>
                                <div class="right">
                                    <el-input v-model="contractCode" placeholder="请输入合作编号"></el-input>
                                </div>
                            </div>

                            <!--  选择投顾方 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>合作方</span></div>
                                <div class="right">
                                    <el-select filterable v-model="tougu" placeholder="请选择">
                                        <el-option v-for="item in options" :key="item.id" :label="item.simpleName"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                             <!--  附件上传 -->
                             <div class="col" style="margin-bottom: 20px;">
                                <div class="left">附件上传</div>
                                <div class="right">
                                    <p style="font-size: 14px;color: #475173;margin-top: 7px;margin-bottom: 5px;">
                                        只能上传docx格式文件。 </p>

                                    <el-upload ref="my-upload" class="avatar-uploader"
                                        :action="this.$store.state.api + '/ad/upload/upload_file'" :on-remove="delBtn"
                                        name="file" accept=".docx,.doc" :limit=1 :on-success="handleAvatarSuccess">
                                        <i
                                            style="color: #fff;width: 80px;height: 24px;background-color: #62DCB5;text-align: center;border-radius: 2px;display: block;font-size: 14px;line-height: 24px;">上传文件</i>
                                    </el-upload>
                                </div>
                            </div>

                            <!-- 尽调表上传 -->
                            <!--  附件上传 -->

                            <!--  备注 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>&nbsp;</span>备注</span></div>
                                <div class="right">
                                    <el-input type="textarea" v-model="remarks" :rows="3"></el-input>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="form_btn">
                        <!-- <button @click="add_close">取消</button> -->
                        <button @click='submit'>提交</button>
                    </div>
                </div>
            </div>
        </transition>

        <transition name="el-fade-in-linear">
            <!--  合作续签 -->
            <div class="popContainer" v-show="Renewal">
                <div class="add" :style="{ width: '680px',paddingBottom:'20px' }">
                    <div class="close"></div>
                    <div class="Top" :style="{ width: '680px' }">
                        合作续签
                    </div>
                    <span class="close iconfont icon-close_round_fill_bold
        " @click="Renewal_close"></span>
                    <div class="form_box" style="width: 100%;">
                        <div class="form" style="display: block;width: 480px;margin-left: 58px;">

                            <!-- 合作续签 -->



                            <!--  合起始日 -->
                            <div class="col" style="margin-bottom: 20px;margin-top: 20px;">
                                <div class="left"><span>*&nbsp;</span>合作起始日</span></div>
                                <div class="right">
                                    <el-input v-model="xq_startTime" disabled></el-input>
                                </div>
                            </div>

                            <!--  合作结束日 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>合作结束日</span></div>
                                <div class="right">
                                    <el-date-picker v-model="xq_endTime" type="date" value-format="yyyy/MM/dd"
                                        placeholder="请选择合作结束日期">
                                    </el-date-picker>
                                </div>
                            </div>

                            <!--  合作编号 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>合作编号</span></div>
                                <div class="right">
                                    <el-input v-model="xq_contractCode" disabled></el-input>
                                </div>
                            </div>

                            <!--  选择投顾方 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>合作方</span></div>
                                <div class="right">
                                    <el-input v-model="tg" disabled></el-input>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="form_btn">
                        <!-- <button @click="Renewal_close">取消</button> -->
                        <button @click='Renewal_submit'>提交</button>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>
<script>

    import hhead from '../header/index';
    import crmNav from '../../../components/crmNav/index';
    import './style.css';
    export default {
        components: { hhead, crmNav },
        data() {
            return {
                contractNum: '',//合作编号搜索
                investorName: '',//投顾名称搜索
                input123: '',
                pageLength: null, //分页长度
                length: '', //账户列表总数

                xq_id: null,//合作续签id
                xq_endTime: '',//续签结束日
                xq_startTime: '',//续签起始日
                xq_contractCode: '',//续签合作编号
                tg: '',//合作续签投顾方
                Renewal: false,//合作续签遮罩层
                api: this.$store.state.api,
                MHeight: document.documentElement.clientHeight - 94 + 'px',
                contractList: [],//所有合作
                Path: '',// 合作地址
                // Path_t:'',// 尽调表地址
                addShow: false,
                contractCode: '',//合作编号
                startDate: '',//起始日期
                endDate: '',//结束日期
                remarks: '',//备注
                page: 0,
                option: [{
                    value: '0',
                    label: '合作中'
                }, {
                    value: '2',
                    label: '合作终止'
                }],
                value: '',
                disabledDate(time) {
                    return time.getTime() > Date.now()
                },
                shortcuts: [{
                    text: 'Today',
                    value: new Date(),
                }, {
                    text: 'Yesterday',
                    value: (() => {
                        const date = new Date()
                        date.setTime(date.getTime() - 3600 * 1000 * 24)
                        return date
                    })(),
                }, {
                    text: 'A week ago',
                    value: (() => {
                        const date = new Date()
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                        return date
                    })(),
                }],
                options: [],//所有投顾信息
                tougu: '',//选择的投顾ID

            };
        },
        filters: {
            datas: function (date) {
                return date.substr(0, 10).replace(/\//g, '-')
            },
            num: function (n) {
                if (n) {
                    return (Math.round(n * 10000) / 100).toFixed(2) + '%'
                } else {
                    return '0.00%'
                }
            }

        },

        mounted() {


            this.list()
            //  查询所有投顾
            this.$axios.post(
                '/crm/inverstor/queryAllInverstor',
                { apiToken: this.$store.state.usermsg.apiToken }
            ).then(res => {
                // console.log(res)
                // this.tokenInvalid(res)
                if (res.data.code == 200) {
                    this.options = res.data.data
                }
            })
        },
        methods: {
            currentPage(e) {
                //当前页
                this.page = e;
                this.list();
            },
            reset() {//重置按钮
                this.contractNum = ''
                this.investorName = ''
                this.value = ''
                this.search()
            },
            search() { //搜索按钮
                this.$axios.post(
                    '/crm/contract/queryAllContract',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        contractNum: this.contractNum,
                        investorName: this.investorName,
                        state: this.value,
                        page_no: this.page,
                        size: 15,
                    }
                ).then(res => {
                    //    console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {
                        this.contractList = res.data.data
                        this.length = res.data.data.length
                        this.pageLength = Math.ceil(res.data.data.length / 1.5)
                    }
                })
            },
            RenewalBtn(num, name, time, id, state) {
                //打开合作续签
                if (state == 2) {
                    this.$alert('合作已终止，无法续签', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true
                    }).then(() => {
                        this.clear()
                    }).catch(() => { });
                } else {

                    this.Renewal = true
                    this.xq_startTime = time.substr(0, 10).replace(/\//g, '-')
                    this.xq_contractCode = num
                    this.tg = name
                    this.xq_id = id
                }
            },
            Renewal_close() {
                //关闭合作续签
                this.clear()
            },
            Renewal_submit() {
                // 提交合作续签
                if (this.xq_endTime) {
                    this.$axios.post(
                        '/crm/contract/Renew',
                        {
                            apiToken: this.$store.state.usermsg.apiToken,
                            endTime: this.xq_endTime,
                            contractId: this.xq_id
                        }
                    ).then(res => {
                        //   console.log(res)
                        this.tokenInvalid(res)
                        if (res.data.code == 200) {
                                this.clear()
                                this.list()
                            // this.$alert('操作成功', {
                            //     confirmButtonText: '确定',
                            //     type: 'success',
                            //     center: true
                            // }).then(() => {
                            // }).catch(() => { });
                        } else {
                            this.$alert(res.data.message, {
                                confirmButtonText: '确定',
                                type: 'error',
                                center: true
                            }).then(() => { }).catch(() => { });
                        }
                    })
                } else {
                    this.$alert('请选择合作结束日', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true
                    }).then(() => { }).catch(() => { });
                }
            },
            details(id, entConId) {
                // 查看合作详情
                this.$router.push('/crm/contract/CDetails?id=' + id + '&entConId=' + entConId)
            },
            hzStop(id, num, state) {
                //合作终止
                if (state == 2) {
                    this.$alert('合作已终止', {
                        confirmButtonText: '确定',
                        type: 'warning',
                        center: true
                    }).then(() => { }).catch(() => { });
                } else {

                    this.$confirm(`您确定要终止合作“${num}”吗`, {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true
                    }).then(() => {
                        this.$axios.post(
                            '/crm/contract/StopOrShutdown',
                            {
                                apiToken: this.$store.state.usermsg.apiToken,
                                state: 2,
                                contractId: id
                            }
                        ).then(res => {
                            //   console.log(res)
                            this.tokenInvalid(res)
                            if (res.data.code == 200) {
                                this.list()
                                // this.$alert('操作成功', {
                                //     confirmButtonText: '确定',
                                //     type: 'success',
                                //     center: true
                                // }).then(() => { }).catch(() => { });
                            } else {
                                this.$alert(res.data.message, {
                                    confirmButtonText: '确定',
                                    type: 'error',
                                    center: true
                                }).then(() => {

                                }
                                ).catch(() => { });
                            }
                        })
                    }).catch(() => {

                    });
                }
            },
            htStop(id, num, state) {
                //合作暂停
                if (state == 2) {
                    this.$alert('合作已终止', {
                        confirmButtonText: '确定',
                        type: 'warning',
                        center: true
                    }).then(() => { }).catch(() => { });
                } else if (state == 1) {
                    this.$alert('合作已暂停，请勿重复操作', {
                        confirmButtonText: '确定',
                        type: 'warning',
                        center: true
                    }).then(() => { }).catch(() => { });

                }
                else {

                    this.$confirm(`您确定要暂停合作“${num}”吗`, {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true
                    }).then(() => {
                        this.$axios.post(
                            '/crm/contract/StopOrShutdown',
                            {
                                apiToken: this.$store.state.usermsg.apiToken,
                                state: 1,
                                contractId: id
                            }
                        ).then(res => {
                            // console.log(res)
                            this.tokenInvalid(res)
                            if (res.data.code == 200) {
                                this.list()
                                this.$alert('操作成功', {
                                    confirmButtonText: '确定',
                                    type: 'success',
                                    center: true
                                }).then(() => { }).catch(() => { });
                            } else {
                                this.$alert(res.data.message, {
                                    confirmButtonText: '确定',
                                    type: 'error',
                                    center: true
                                }).then(() => { }).catch(() => { });
                            }
                        })
                    }).catch(() => {

                    });
                }
            },
            del(id, num) {
                //删除合作
                this.$confirm(`您确定要删除合作“${num}”吗`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.$axios.post(
                        '/crm/contract/del',
                        {
                            apiToken: this.$store.state.usermsg.apiToken,
                            entConId: id
                        }
                    ).then(res => {
                        //   console.log(res)
                        this.tokenInvalid(res)
                        if (res.data.code == 200) {
                            this.list()
                            this.$alert('删除成功', {
                                confirmButtonText: '确定',
                                type: 'success',
                                center: true
                            }).then(() => { }).catch(() => { });
                        } else {
                            this.$alert(res.data.message, {
                                confirmButtonText: '确定',
                                type: 'error',
                                center: true
                            }).then(() => { }).catch(() => { });
                        }
                    })
                }).catch(() => {

                });
            },
            list() {

                //获取所有合作
                this.$axios.post(
                    '/crm/contract/queryAllContract',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        contractNum: this.contractNum,
                        investorName: this.investorName,
                        state: this.value,
                        page_no: 1,
                        size: 100000,
                    }
                ).then(res => {
                    //    console.log(res)

                    if (res.data.code == 200) {

                        this.length = res.data.data.length
                        this.pageLength = Math.ceil(res.data.data.length / 1.5)
                    }
                })


                //获取所有合作
                this.$axios.post(
                    '/crm/contract/queryAllContract',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        contractNum: this.contractNum,
                        investorName: this.investorName,
                        state: this.value,
                        page_no: this.page,
                        size: 15,
                    }
                ).then(res => {
                       console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {
                        this.contractList = res.data.data
                    }
                })
            },
            clear() {
                //清除输入框
                this.Path = ''
                this.contractCode = ''
                this.startDate = ''//起始日期
                this.endDate = ''//结束日期
                this.remarks = ''//备注
                // this.options= []//所有投顾信息
                this.tougu = ''//选择的投顾ID
                this.addShow = false
                this.Renewal = false
                this.xq_startTime = ''
                this.xq_contractCode = ''
                this.tg = ''
                this.xq_id = ''
            },
            handleAvatarSuccess(res, file) {
                //上传合作
                //   console.log(res);
                if (res.code == 200) {
                    this.Path = res.data.filePath;
                }
            },
            // handleAvatarSuccess_t(res, file) {
            //   //上传尽调表
            //   console.log(res);
            //   if (res.code == 200) {
            //     this.Path_t = res.data.filePath;
            //   } 
            // },
            delBtn() {
                //移除文件
                this.path = ''
            },
            delBtn_t() {
                //移除文件
                this.path_t = ''
            },
            submit() {
                //   console.log(this.startDate,this.endDate)

                if ( this.contractCode && this.startDate && this.endDate && this.tougu) {
                    this.$axios.post(
                        '/crm/contract/addContract',
                        {
                            remark: this.remarks,
                            apiToken: this.$store.state.usermsg.apiToken,
                            contractNum: this.contractCode,
                            startTime: this.startDate,
                            endTime: this.endDate,
                            invId: this.tougu,
                            contractFile: this.Path,

                            investorInfoFile: this.Path,
                        }
                    ).then(res => {
                        //   console.log(res)
                        this.tokenInvalid(res)
                        if (res.data.code == 200) {
                            this.$refs['my-upload'].clearFiles()
                            this.clear()
                                this.list()                          
                        } else {
                            this.$alert(res.data.message, {
                                confirmButtonText: '确定',
                                type: 'error',
                                center: true
                            }).then(() => {

                            }
                            ).catch(() => { });
                        }
                    })
                } else {
                    this.$alert('验证错误:请确认信息是否填写完整', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true
                    }).then(() => { }
                    ).catch(() => { });
                }
            },
            add_close() {
                this.$refs['my-upload'].clearFiles()
                this.clear()
            },
            add() {
                this.addShow = true
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/view/crm/contract/index.vue